<template>
  <DefaultModal v-if="visible" :show-close-btn="false" @close="$emit('close')">
    <template #header>
      <DefaultModalTitle>{{ title }}</DefaultModalTitle>
    </template>

    <template #body>
      <div class="reject-reason">
        <p class="explanation">Förklaring:</p>

        <span v-if="reason">"{{ reason }}"</span>
        <span v-else>(Förklaring saknas)</span>
        <p class="rejected-by">
          {{ name ? `- ${name}` : '(Namn saknas)' }}
        </p>
      </div>
    </template>

    <template #footer>
      <BaseButton :is-rounded="true" :is-default="true" @click="$emit('close')"
        >Stäng</BaseButton
      >
    </template>
  </DefaultModal>
</template>

<script>
import { getNotes } from '@/services/appService';

import DefaultModal from '@/components/DefaultModal.vue';
import BaseButton from '@/components/BaseButton.vue';
import DefaultModalTitle from '@/components/DefaultModalTitle.vue';
import statusTypes from '@/utils/statusTypes';

export default {
  components: {
    DefaultModal,
    BaseButton,
    DefaultModalTitle
  },
  props: {
    title: {
      type: String,
      default: 'Nekat byte'
    },
    applicationId: {
      type: String,
      default: ''
    },
    applicationStatus: {
      type: String,
      default: ''
    },
    note: {
      type: Object,
      default: null
    }
  },
  emits: ['close'],
  data() {
    return {
      fetchedReason: '',
      fetchedName: '',
      fetchedVisible: true
    };
  },
  computed: {
    hasNote() {
      return !!this.note;
    },
    reason() {
      if (this.hasNote) return this.note?.text || '';
      return this.fetchedReason;
    },
    name() {
      if (this.hasNote) {
        const first = this.note?.firstName;
        const last = this.note?.lastName;
        if (!first && !last) return '';
        return `${first || ''} ${last || ''}`.trim();
      }
      return this.fetchedName;
    },
    visible() {
      if (this.hasNote) return true;
      return (
        this.applicationStatus === statusTypes.REJECTED && this.fetchedVisible
      );
    }
  },
  async mounted() {
    if (this.hasNote) return;
    if (!this.applicationId) return;
    try {
      const notes = await getNotes(this.applicationId, ['REJECTION']);
      const latestRejectNote = notes[notes.length - 1];
      if (latestRejectNote) {
        this.fetchedReason = latestRejectNote.text;
        this.fetchedName = `${latestRejectNote.firstName} ${latestRejectNote.lastName}, ${latestRejectNote.landlordName}`;
      } else {
        this.fetchedVisible = false;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
</script>

<style scoped>
.reject-reason {
  font-size: 1.8rem;
  font-weight: 400;
  width: 500px;
  max-width: 100%;
  white-space: normal;
  line-height: 1.4;
  color: var(--color-dark-blue);
  font-style: italic;
}

.reject-reason .explanation {
  color: var(--color-dark-blue);
  margin-bottom: 0.2rem;
  font-style: normal;
}

.rejected-by {
  margin-top: 0.5rem;
  font-style: normal;
}
</style>
